import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
export function WhoIsForSection() {
  const forItems = ['Mujeres de más de 30 años con digestión lenta o colon irritable.', 'Quienes sienten que "todo les cae pesado", incluso el agua.', 'Profesionales o mamás con poco tiempo que necesitan soluciones prácticas.', 'Personas que quieren ver un cambio real en su abdomen antes de un evento o el fin de semana.'];
  return <section className="w-full py-16 md:py-24" style={{
    backgroundColor: '#F0F7F4'
  }} data-id="element-221">
      <div className="max-w-4xl mx-auto px-4" data-id="element-222">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} data-id="element-223">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-center mb-12" style={{
          color: '#1A1A1A'
        }} data-id="element-224">
            ¿Para quién es este protocolo?
          </h2>

          <div className="bg-white rounded-3xl p-6 md:p-10 shadow-sm" data-id="element-225">
            <ul className="space-y-5" data-id="element-226">
              {forItems.map((item, index) => <motion.li key={index} className="flex items-start gap-4" initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} data-id="element-227">
                  <CheckCircleIcon className="w-6 h-6 flex-shrink-0 mt-0.5" style={{
                color: '#C9A96E'
              }} data-id="element-228" />
                  <span className="text-base md:text-lg" style={{
                color: '#4A4A4A'
              }} data-id="element-229">
                    {item}
                  </span>
                </motion.li>)}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>;
}